import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ResourcesSection } from './components/ResourcesSection';
import { KnowledgeSection } from './components/KnowledgeSection';
import { CoastalManagement } from './components/CoastalManagement';
import { MaritimeSafety } from './components/MaritimeSafety';
import { EnergySection } from './components/EnergySection';
import { TourismSection } from './components/TourismSection';
import { ServicesSection } from './components/ServicesSection';
import { DigitalGovernance } from './components/DigitalGovernance';
import { NewsSection } from './components/NewsSection';
import { EventsSection } from './components/EventsSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-0">
      <Header data-id="element-1" />
      <Hero data-id="element-2" />
      <ResourcesSection data-id="element-3" />
      <KnowledgeSection data-id="element-4" />
      <CoastalManagement data-id="element-5" />
      <MaritimeSafety data-id="element-6" />
      <EnergySection data-id="element-7" />
      <TourismSection data-id="element-8" />
      <ServicesSection data-id="element-9" />
      <DigitalGovernance data-id="element-10" />
      <NewsSection data-id="element-11" />
      <EventsSection data-id="element-12" />
      <Footer data-id="element-13" />
    </div>;
}